import { render, staticRenderFns } from "./editdictiona.vue?vue&type=template&id=3d627ec1&scoped=true&"
import script from "./editdictiona.vue?vue&type=script&lang=js&"
export * from "./editdictiona.vue?vue&type=script&lang=js&"
import style0 from "./editdictiona.vue?vue&type=style&index=0&id=3d627ec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d627ec1",
  null
  
)

export default component.exports